import {connect} from 'react-redux'
import {USER_MENUS} from '../../constants/menus/userMenus.jsx';
import NavigationMenu from '../../components/panel/NavigationMenu.jsx';
import Skinning from '../../components/modal/Skinning.jsx';
import Popup from '../../components/modal/popup.jsx'
import {DOWNLOAD_WIN} from '../../constants/config'
import UsdtWithdrawal from "./reports/popPage/usdtWithdrawal";
// import policyLogo from '../../i/pc-day/df/policy-logo.jpg';
class RichHeader extends React.Component {

  constructor(props) {
    super(props);
    this.handleHideMoney = this.handleHideMoney.bind(this);
    this.openSkinningModal = this.openSkinningModal.bind(this);
    this.hideSkinningModal = this.hideSkinningModal.bind(this);
    this.logout = this.logout.bind(this);
    this.DownloadWinCEF = this.DownloadWinCEF.bind(this);
    this.openModal = this.openModal.bind(this);
    this.refreshBalance = this.refreshBalance.bind(this);
    this.state = {
      displayMoney: true,
      displaySkinning: false,
      notice: [],
      showRecharge: false,
      navIndex: 0,
      refresh: false,
      showPickWithdrawal:false,
      showUsdtWindow:false,
      hasGooglePwd:false,
      showPolicy: false,
      showTerms:false
    }
  }
  componentDidMount() {
    this.props.$$USER.getWithdrawType()
    this.props.$$USER.getPlatformBalance('wali');
    this.props.$$USER.getPlatformBalance('yy');
    this.props.$$USER.getPlatformBalance('kgame');
    // 监听IFRAME充值事件
    window.addEventListener('message', this.handleChargePrompts, false)
  }

  //极速充值订单提示
  handleChargePrompts = (event) => {
    if(event.data == 'openOrderPrompts'){
      this.props.$$BASE.openConfirm(
        '请完成上一笔充值后再使用该渠道,如超过15分钟未到账,请联系客服处理.',
        ()=> {this.props.$$BASE.closeIframeModal();; window.location.hash = '#/report/user/getopflists?new=1&version=x'},
        ()=>  this.props.$$BASE.closeConfirm(),
        '提示',
         null,
         null,
         null,
        '查看订单'
      )
    }
  }

  // 打开弹出框
  openModal(url, title, width, height) {
    this.props.$$BASE.openIframeModal(url, title, width, height);
  }

  // 隐藏显示金额
  handleHideMoney() {
    const __base = this.props.__BASE.toJS();
    if (__base.config.showBalance) {
      this.props.$$BASE.hideBalance();
    } else {
      this.props.$$BASE.showBalance();
    }
  }

  // 显示切换皮肤框
  openSkinningModal() {
    this.setState({
      displaySkinning: true
    })
    this.props.$$BASE.openLoading()
  }

  // 隐藏切换皮肤框
  hideSkinningModal() {
    this.setState({
      displaySkinning: false
    })
    this.props.$$BASE.closeLoading()
  }

  // 登出
  logout() {
    this.props.$$BASE.openConfirm('are you sure you want to quit?', this.props.$$USER.logout);
  }

  // 客户端下载
  DownloadWinCEF() {
    window.open(DOWNLOAD_WIN, 'client download');
  }

  refreshBalance() {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer)
    }
    this.setState({
      refresh: true
    })
    this.refreshTimer = setTimeout(() => {
      this.setState({
        refresh: false
      })
      this.props.$$USER.getLotteryBalance();
    }, 500)


  }

  componentWillUnmount() {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer)
    }
  }

  //根据hash 当前 在第几个导航上，
  getMenuIndex() {
    let activeIndex = 0;

    for (let i = 0; i < USER_MENUS.length; i++) {
      let item = USER_MENUS[i];
      let hash = window.location.hash;
      //判断是不是第0个item ，并且 路由为 '#/'。则为在第0个导航上。
      if (item.menuFlag == USER_MENUS[0].menuFlag && hash == '#/') {
        activeIndex = 0;
        break;
      }
      //如果不是第0个导航上，根据hash 是否包含 menuFlag判断是否在当前的 导航上
      if (item.menuFlag != USER_MENUS[0].menuFlag && hash.indexOf(item.menuFlag) >= 0) {
        activeIndex = i;
        break;
      }
    }

    return activeIndex;
  }
  showUsdtWindow(){
    this.props.$$USER.checkUsdtAvailable((e)=>{
      if (e.data.is_enable == true) {
        this.setState({
          showPickWithdrawal:false,
          showUsdtWindow:true,
          hasGooglePwd:e.data.is_enable_two_fa
        })
      }else {
        this.props.$$BASE.openAlert('USDT提款不可用!')
      }
    })
  }

  render() {
    const __user = this.props.__USER.toJS();
    const __base = this.props.__BASE.toJS();
    const __info = __user.info;
    const __balance = __user.balance;
    const ads = _.filter(__base.ads, (item) => item.type == 'menus');
    const {navIndex} = this.state;
    let {className} = this.props
    className = className || ""
    return (
      <header className={"header-framework " + className}>
        <div className="user_info_bg">
          <div className="user_info">
            <div className="user_info_left">
              welcome，
              <span className="user_username">{__info.nickname}</span>
              {/* <a className="ui_message" onClick={this.openModal.bind(this, "user/messages?width=1050", "查看站内信", 900, 610)}>
                <i className="ic-message"></i>
                <span className="ui_msgnum" style={{ display: __info.messages > 0 ? "block" : "none" }}></span>
              </a> */}
              &nbsp; reserve information：
              <span className="ui_yuliu">{__info.preinfo}</span>
              {window.vers == "df" && (
                <a onClick={() => this.setState({ showPolicy: true })} className="policy">
                  Responsible Gaming Policy
                </a>
              )}
              {window.vers == "df" && (
                <a onClick={() => this.setState({ showTerms: true })} className="policy">
                  Terms and Use
                </a>
              )}
              <a onClick={this.logout} className="ui_logout">
                safe exit
              </a>
            </div>
            <div className="user_info_right">
              <div className="money-left">
                <span>balance: </span>
                <span className="t_money">
                  ￥
                  {__base.config.showBalance ? (
                    <span>
                      <span>{this.state.refresh ? "refreshing" : $.formatMoney(__balance.lottery, 4, "")}</span>
                      <span className="refresh" onClick={this.refreshBalance}>
                        refresh
                      </span>
                    </span>
                  ) : (
                    <span>************</span>
                  )}
                </span>
                <a className="pointer" onClick={this.handleHideMoney}>
                  {__base.config.showBalance ? <i className="ic-unlook"></i> : <i className="ic-look"></i>}
                </a>
              </div>
              <a
                onClick={this.openModal.bind(this, "emaildeposit/main", "recharge", 900, 660)}
                title="recharge"
                className="t_btn chongzhi">
                recharge
              </a>
              <a
                title="withdrawal"
                className="t_btn tixian"
                onClick={() => {
                  this.setState({ showPickWithdrawal: true });
                }}>
                withdrawal
              </a>
            </div>
          </div>
        </div>
        <Popup
          display={this.state.showPickWithdrawal}
          width={820}
          height={580}
          onclose={() => this.setState({ showPickWithdrawal: false })}>
          <div className="pick-withdrawal-window">
            <div className="modal-title HX">withdrawal</div>
            <p className="top-text">Please select withdrawal method</p>
            {__user.withdraw_type_data.status == true && (
              <div>
                <p
                  className="pick-btn"
                  onClick={() =>
                    this.props.$$BASE.openIframeModal(
                      "emaildeposit/main?controller=security&action=platwithdraw&isiframe=1",
                      "提款",
                      820,
                      600
                    )
                  }>
                  <span className="tip">bonus since 0.1%</span>
                  <span>极速提款1</span>
                </p>
                s{" "}
                <p
                  className="pick-btn"
                  onClick={() =>
                    this.props.$$BASE.openIframeModal(
                      "emaildeposit/main?controller=security&action=platwithdraw",
                      "提款",
                      820,
                      600
                    )
                  }>
                  银行卡提款
                </p>
              </div>
            )}
            {__user.withdraw_type_data.status == false && (
              <div>
                <p
                  className="pick-btn"
                  onClick={() =>
                    this.props.$$BASE.openIframeModal(
                      "emaildeposit/main?controller=security&action=platwithdraw&isiframe=1",
                      "提款",
                      820,
                      600
                    )
                  }>
                  <span className="tip">bonus since 0.1%</span>
                  <span>极速提款1</span>
                </p>
                <p
                  className="pick-btn"
                  onClick={() =>
                    this.props.$$BASE.openIframeModal(
                      "emaildeposit/main?controller=security&action=platwithdraw",
                      "提款",
                      820,
                      600
                    )
                  }>
                  银行卡提款
                </p>
                {/* <p className="pick-btn no-click">USDT提款(更安全便捷)</p> */}
              </div>
            )}
            {/* <p className="text-1">
              可用提款余额共计：{__user.withdraw_type_data.availablebalance}元，其中{__user.withdraw_type_data.digitalrest}
              元可以使用USDT提款取出
            </p> */}
            {/*<p className="process-text">USDT介绍及提款流程</p>*/}
          </div>
        </Popup>
        <Popup
          display={this.state.showUsdtWindow}
          width={820}
          className="notice"
          height={567}
          onclose={() => this.setState({ showUsdtWindow: false })}>
          <UsdtWithdrawal onclose={() => this.setState({ showUsdtWindow: false })} hasGooglePwd={this.state.hasGooglePwd} />
        </Popup>
        <Popup display={this.state.showPolicy} width={820} height={550} onclose={() => this.setState({ showPolicy: false })}>
          <div className="modal-title-policy HX">Responsible Gaming Policy</div>
          <div className="policy-box">
            <h5>
              <img src={require("../../i/pc-day/df/policy-logo.jpg")} alt="logo" />
            </h5>
            <h2>ACSTREAM MANAGEMENT INC. </h2>
            {/* <h1>RESPONSIBLE GAMING POLICY</h1>
              <h3>Responsible Gaming Statement</h3>
              <p>The Company is committed to doing everything possible to give its Customers an enjoyable gaming experience, whilst recognizing that gambling can cause problems for a minority of individuals.  To ensure that you continue to enjoy safe and manageable play, we fully support Responsible Gaming and have numerous measures in place to offer checks.</p>
              <h3>Resonsible Gaming Information</h3>
              <p>On the Licensee’s website, under section of “Responsible Gaming” the Company will provide the following information to its customers:</p> */}
            <i />
            <h2>ACSTREAM MANAGEMENT INC. as an entity is an advocate of Responsible Gaming among its patrons.</h2>
            {/* <h3 style={{'textDecoration': 'none'}}>Do you play too much?</h3> */}
            <p>
              The Philippine Code of Practice on Responsible Gaming aptly puts it: while gaming is an “enjoyable form of
              entertainment,” it can have a negative impact to the player, his family and his community when done in excess. For
              this reason, ACSTREAM MANAGEMENT INC. established its Responsible Gaming Program aimed at: (1) creating a safe and
              responsible gaming environment; (2) creating awareness among its employees, clients and the community of the harm
              associated with gambling-related problems; and (3) offering appropriate support and assistance to clients with
              gaming related behavioral problems.
            </p>
            <p>
              ACSTREAM MANAGEMENT INC. Responsible Gaming Program features three (3) pillars: (1) information dissemination on
              responsible gaming; (2) assistance to gaming members seeking professional help; and (3) exclusion procedure.
            </p>
            <p>Information Dissemination: Awareness on Responsible Gaming</p>
            <p>
              Problem Gambling refers to a situation where a person engages in excessive gambling. It may be evident in one or
              more of the following behaviors:
            </p>
            <br />
            <p>The following 10 questions can help you identify your degree of gambling risk:</p>
            <br />
            <p>1. Mood swings. One is easily irritated or argumentative.</p>
            <p>
              2. Excessive time spent in casinos. One spends more time engaging in gaming activities than in his ordinary routine
              – work, business, family.
            </p>
            <p>
              3. Neglecting personal needs/responsibilities. One does not bother to attend to his personal needs or to take charge
              of responsibilities to himself, to his family, to his work and others.
            </p>
            <p>4. Sudden need for money.</p>
            <p>5. Significant deviation from one’s ordinary routine.</p>
            <p>6. Being secretive and/or lying about things done during leisure time.</p>
            <br />
            <p>
              Excessive gambling may have negative effects on the lives of a player and his family. On a personal level, people
              who engage in Problem Gambling may suffer depression and anxiety, job loss and financial hardships. They may neglect
              their duties and responsibilities to their family and cause relationship breakdown. They may also be involved in
              theft, financial fraud, and scams in order to fund their gambling activities.
            </p>
            <br />
            <p>Government Mandated Restrictions</p>
            <p>
              Pursuant to existing laws, rules and regulations, all residents of the Philippines or users using Philippine IP
              addresses are not allowed to use the features of the gaming website. This is in addition to the mandated
              prohibitions such as: Government officials connected directly with the operation of the Government or any of its
              agencies; Members of the Armed Forces of the Philippines, including the Army, Navy, Air Force or the Philippine
              National Police; Persons under 21 years old or students of any school, college or university in the Philippines.
            </p>
            <p>Membership Assistance: Helpdesk and Seeking Professional Help</p>
            <p>
              Gaming members who feel the need for professional help may likewise send information to the following email address:
              responsible.gaming@xionweitechnologies.com.
            </p>
            <p>
              ACSTREAM MANAGEMENT INC. can endorse those of its clients to Life Change Recovery Center, a professional counseling
              and treatment facility for persons with psychiatric conditions, addictions or psychological and/or behavioral
              problems. Anyone who needs said treatment may directly contact the following:
            </p>
            <h3 style={{ textDecoration: "none", marginBottom: 0 }}>Life Change Recovery Center</h3>
            <h2 style={{ textAlign: "left" }}>Address:</h2>
            <p>105 Scout Rallos Street, Kamuning, Barangay Sacred Heart, Quezon City</p>
            <h2 style={{ textAlign: "left" }}>Contact Numbers: </h2>
            <p>(02) 3415- 6529, (02) 3415- 7964, (02) 3415- 6529</p>
            <h2 style={{ textAlign: "left" }}>Website:</h2>
            <span>Web:</span>{" "}
            <a href=" lifechangerecovery.com" target="_blank">
              lifechangerecovery.com
            </a>
            <h2 style={{ textAlign: "left" }}>Foundation:</h2>
            <p>364 Aguirre Avenue,Phase 3, BF Homes, Paranaque City</p>
            <h2 style={{ textAlign: "left" }}>Phone:</h2>
            <p>(02) 7622-0193 Mobile: 0917- 5098826</p>
            <h2 style={{ textAlign: "left" }}>New Manila Branch:</h2>
            <p>12 Onestes Ln, Mariposa Street, Quezon City Phone: (02) 7503- 3483 Mobile: 09175098826</p>
            <h2 style={{ textAlign: "left" }}>Cebu Branch:</h2>
            <p>806 Ouano St., Ibabao- Estancia, Mandaue City, Cebu Phone: (032) 420-9287</p>
            <p>Mobile: 0917- 7046659</p>
            <p>Gamblers Anonymous Philippines Phone: 0976- 0384333</p>
            <p>Mobile: 0917- 3062232</p>
            <span>Website:</span>{" "}
            <a href="gaphilippines.org" target="_blank">
              gaphilippines.org
            </a>
            <h2 style={{ textAlign: "left" }}>Philippine Amusement & Gaming Corporation Main Corporate Office:</h2>
            <p>IMET BPO Tower,</p>
            <p>CBP-1A, Metropolitan Park,</p>
            <h2 style={{ textAlign: "left" }}>Roxas Boulevard, Pasay City</h2>
            <p>Contact Numbers: (02) 7755- 3199, (02) 7755-3299, (02) 7755- 3899</p>
            <p> Website:pagcor.ph/regulatory/responsible.php</p>
            <h3 style={{ textDecoration: "none", marginBottom: 0 }}>Procedure for Exclusion</h3>
            <p>
              Gaming members who may want to exclude themselves from playing in any of ACSTREAM MANAGEMENT INC.'s, gaming sites
              may do so by completing the form in this link and submitting the required documents. Likewise, the relatives of a
              gaming member may file an application for exclusion subject to the conditions imposed by the Code of Practice.
            </p>
            <p>Click this link for the Application for Exclusion.</p>
            <a href="https://pagcor.ph/regulatory/exclusion.php" target="_blank">
              https://pagcor.ph/regulatory/exclusion.php
            </a>
          </div>
        </Popup>
        <Popup display={this.state.showTerms} width={820} height={550} onclose={() => this.setState({ showTerms: false })}>
          <div className="modal-title-policy HX">Terms and Conditions</div>
          <div className="policy-box">
            <h5>
              <img src={require("../../i/pc-day/df/policy-logo.jpg")} alt="logo" />
            </h5>
            <h2>Terms and Conditions </h2>
            <i />
            <h2 style={{ textAlign: "left" }}>1. PRIVACY</h2>
            <p>
              ACSTREAM MANAGEMENT INC is committed to protecting your personal information. This Privacy Policy lets you know what
              information we collect when you use our services, why we collect this information and how we use the collected
              information.
            </p>
            <p>
              Please note that this Privacy Policy will be agreed between you and ACSTREAM INC. (‘We’, ‘Us’ or ‘Our’, as
              appropriate). This Privacy Policy is an integrated part of ACSTREAM MANAGEMENT INC’s Terms and Conditions.
            </p>
            <p>
              We may periodically make changes to this Privacy Policy and will notify you of these changes by posting the modified
              terms on our platforms. We recommend that you revisit this Privacy Policy regularly.
            </p>
            <h2 style={{ textAlign: "left" }}>2. INFORMATION COLLECTED</h2>
            <p>
              We consider information that may be used to identify an individual, including, but not limited to, first and last
              name, date of birth, home or other physical address, email address, phone number or other relevant information to be
              Personal Information (‘Personal Information’). You may be asked to provide Personal Information when you use our
              website, register for an account or use our services. The Personal Information that we collect may include
              information such as: contact information (including telephone number), shipping information, billing information,
              transaction history, website usage preferences, and feedback regarding the Services. This information is held by us
              on servers based in Germany and elsewhere from time to time. When you interact with the services, our servers keep
              an activity log unique to you that collects certain administrative and traffic information including: source IP
              address, time of access, date of access, web page(s) visited, language use, software crash reports and type of
              browser used. This information is essential for the provision and quality of our services. We do not collect
              Personal Information about you without your knowledge.
            </p>
            <h2 style={{ textAlign: "left" }}>3. MEANS OF COLLECTING AND PROCESSING DATA</h2>
            <p>
              We may automatically collect certain data as discussed above and receive Personal Information about you where you
              provide such information through the services or other communications and interactions on the ACSTREAM MANAGEMENT
              INC site. We may also receive Personal Information from online vendors and service providers, and from customer
              lists lawfully acquired from third-party vendors. In addition, we may engage the services of third-party service
              providers to provide technical support process your online transactions and maintain your account. We will have
              access to any information you provide to such vendors, service providers and third-party e-commerce services, and we
              will use the Personal Information as set out in this Privacy Policy below. This information will only be disclosed
              to third parties outside the company in accordance with this Privacy Policy. We take steps to ensure that our
              arrangements with third-party service providers and online vendors protect your privacy.
            </p>
            <h2 style={{ textAlign: "left" }}>4. INFORMATION USE</h2>
            <p>
              We use the Personal Information we collect from you to deliver our Services, to provide customer support, to
              undertake necessary security and identify verification checks, to process any of your online transactions, to assist
              your participation in third-party promotions, meet certain business requirements and for any other purpose related
              to the operation of the Services. As such, we may share your Personal Information with our carefully selected
              partners (including any other parties that have data sharing arrangements with the latter).
            </p>
            <p>
              Your Personal Information may also be used by us to provide you with: (1) promotional offers and information
              regarding our products and services; and (2) promotional offers and information regarding the products and services
              of our partners, in order to enlarge the range of provided products and improve our customer service. From
              time-to-time, we may request information from you via surveys or contests. Participation in these surveys or
              contests is completely voluntary and you have the choice of whether or not to disclose such information. Information
              requested may include contact information (such as name, correspondence address and telephone number), and
              demographic information (such as zip or postal code or age). By accepting any contest prize or winnings from us, you
              consent to use of your name for advertising and promotional purposes without additional compensation, except where
              prohibited by law. Unless you have elected not to receive promotional information, we may also use your Personal
              Information (including your email address and phone number) to provide you with information regarding our products,
              services and promotions.
            </p>
            <h2 style={{ textAlign: "left" }}>5. CERTAIN EXCLUDED DISCLOSURES</h2>
            <p>
              We may disclose your Personal Information if required to do so by law, or if we believe in good faith that such
              action is necessary to: (1) comply with any legal process served on us, any of our sites or the services or in
              circumstances where we are under a substantially similar legal obligation; (2) protect and defend our rights or
              property; or (3) act to protect the personal safety of users of the services or the public. If, in our sole
              determination, you are found to have cheated or attempted to defraud us, the company , or any other user of the
              services in any way including but not limited to game manipulation or payment fraud, or if we suspect you of
              fraudulent payment, including use of stolen credit cards, or any other fraudulent activity (including any chargeback
              or other reversal of a payment) or prohibited transaction (including money laundering), we reserve the right to
              share this information (together with your identity) with other online gaming sites, banks, credit card companies,
              appropriate agencies and relevant authorities. (4) For the purpose of research on the prevention of addiction, data
              can be made anonymous and passed on to the respective institutions.
            </p>
            <h2 style={{ textAlign: "left" }}>6. ACCESS</h2>
            <p>
              You may ‘opt out’ of receiving any promotional communications either by choosing to opt out via your account
              settings available on our sites or the services or in an email you receive from us, or at any time by sending an
              email, or by writing to us at Customer Service.
            </p>
            <p>
              In addition, You may contact us if you: 1) want to confirm the accuracy of the Personal Information we have
              collected about you; 2) would like to update your Personal Information; and/or 3) have any complaint regarding our
              use of your Personal Information. If requested, we will (1) update any information you have provided to us, in case
              you prove the necessity for such changes or (2) mark any information to prohibit future use for marketing purposes.
              For the avoidance of doubt, nothing in this Privacy Policy shall prevent us from retaining your Personal Information
              where we are required to do so by law.
            </p>
            <h2 style={{ textAlign: "left" }}>7. COOKIES</h2>
            <p>Information placed on your device</p>
            <p>
              When accessing our services, we may store information on your device. This information is referred to as cookies,
              which are small text files that are stored on your device when you visit online pages that record your preferences.
              We also use Local Shared Objects or ‘flash cookies’. ‘Flash cookies’ are similar to browser cookies. They allow us
              to remember things about your visits across our sites. Neither cookies nor flash cookies can be used to access or
              use other information on your computer. We only use these methods to track your use of our services. Cookies help us
              monitor traffic to the site, improve our services and make it easier and/or more relevant for your use. We use flash
              cookies and third party cookies to help us show you more relevant and desirable advertisements.
            </p>
            <p>Strictly necessary cookies</p>
            <p>
              Strictly necessary cookies are essential to allow a user move around a website and use its features, such as
              accessing secure areas of the website or making financial transactions. Without these cookies, we would not be able
              to make our websites work efficiently.
            </p>
            <p>During the registration process</p>
            <p>
              These cookies will hold information collected during your registration and will allow us to recognize you as a
              customer and provide you with the services you require. We may also use this data to better understand your
              interests while online and to enhance your visits to our platforms.
            </p>
            <p>On our website</p>
            <p>
              For visitors to our website, we use cookies to collect information. Our servers use three different types of
              cookies:
            </p>
            <p>
              A ‘session-based’ cookie: This type of cookie is only allocated to your computer for the duration of your visit to
              our website. A session-based cookie helps you move around our website faster and, if you’re a registered customer,
              it allows us to give you information that is more relevant to you. This cookie automatically expires when you close
              your browser.
            </p>
            <p>
              A ‘persistent’ cookie: This type of cookie will remain on your computer for a period of time set for each cookie.
              Flash cookies are also persistent.
            </p>
            <p>
              ‘Analytical’ cookies: This type of cookie allows us to recognize and count the number of visitors to our site and
              see how visitors use our services. These helps us improve the way our sites work, for example, by ensuring you can
              find what you are looking for easily.
            </p>
            <p>
              You have the ability to accept or decline cookies. Most web browsers automatically accept cookies, but, if you
              prefer, you can usually modify your browser setting to decline cookies. The Help menu on the menu bar of most
              browsers will tell you how to prevent your browser from accepting new cookies, how to have the browser notify you
              when you receive a new cookie and how to disable cookies altogether.
            </p>
            <p>Flash cookies</p>
            <p>
              You can modify your Flash Player settings to prevent the use of flash cookies. The Settings Manager of your Flash
              Player allows you manage your preferences. To disallow flash cookies from all third party content go to the ‘Global
              Storage Settings’ panel of the Settings Manager and de-select the check box labelled ‘Allow third party flash
              content to store information on your computer’ and close the Settings Manager. Alternatively you can also adjust
              your settings for specific websites you visit through the ‘Website Storage Settings’ panel which is also found in
              the Settings Manager.
            </p>
            <p>
              If you are using an old version of Flash Player or older web browser, the Settings Manager may not be available to
              you. We recommend that you ensure that you refresh your Flash Player and browser to the latest available versions.
            </p>
            <p>
              If you choose to decline cookies, you may not be able to experience all of the interactive features on our sites.
            </p>

            <h2 style={{ textAlign: "left" }}>8. CONSENT TO USE OF ELECTRONIC SERVICE PROVIDERS</h2>
            <p>
              In order to play real money games on our services, you will be required to send money to and receive money from us.
              We may use third-party electronic payment systems to process such financial transactions. By accepting this Privacy
              Policy, you expressly consent to Personal Information necessary for the processing of transactions including, where
              necessary, the transfer of information outside of your country. We take steps to ensure that our arrangements with
              payments systems protect your privacy.
            </p>
            <h2 style={{ textAlign: "left" }}>9. CONSENT TO SECURITY REVIEW</h2>
            <p>
              We reserve the right to conduct a security review at any time to validate the registration data provided by you and
              to verify your use of the services and your financial transactions for potential breach of our Terms and Conditions
              and of applicable law. By using our services and thereby agreeing to our Terms and Conditions you authorize us to
              use your Personal Information and to disclose your Personal Information to third parties for the purposes of
              validating the information you provide during your use of our services, including, where necessary, the transfer of
              information outside of your country. Security reviews may include but are not limited to ordering a credit report
              and/or otherwise verifying the information you provide against third-party databases. In addition, to facilitate
              these security reviews, you agree to provide such information or documentation as we may request.
            </p>
            <h2 style={{ textAlign: "left" }}>10. SECURITY</h2>
            <p>
              We understand the importance of security and the techniques needed to secure information. We store all of the
              Personal Information we receive directly from you in an encrypted and password-protected database residing within
              our secure network behind active state-of-the-art firewall software. (Our Services support SSL Version 3 with
              128-bit encryption). We also take measures to ensure our subsidiaries, agents, affiliates and suppliers employ
              adequate security measures.
            </p>
            <h2 style={{ textAlign: "left" }}>11. PROTECTION OF MINORS</h2>
            <p>
              Our Services are not intended for or directed at persons under the age of twenty one (21) (or the lawful age in
              their respective jurisdiction). Any person who provides their information to us through any part of the services
              signifies to us that they are twenty one (21) years of age (or the lawful age in their respective jurisdiction) or
              older. It is our policy to uncover attempts by minors to access our services which may involve having to initiate a
              security review. If we become aware that a minor has attempted to or has submitted personal information via our
              services, we will not accept their information and will take steps to purge the information from our records.
            </p>
            <h2 style={{ textAlign: "left" }}>12. INTERNATIONAL TRANSFERS</h2>
            <p>
              Personal Information collected on the services may be stored and processed in any country in which we or our
              affiliates, suppliers or agents maintain facilities. By using our services, you expressly consent to any transfer of
              information outside of your country (including to countries that may not be assessed as having adequate privacy
              laws). Nevertheless, we take steps to ensure that our agents, affiliates and suppliers comply with our standards of
              privacy regardless of their location.
            </p>
            <h2 style={{ textAlign: "left" }}>13. THIRD-PARTY PRACTICES</h2>
            <p>
              We cannot ensure the protection of any information that you provide to a third-party online site that links to or
              from the services or any information collected by any third party administering our affiliate program (if
              applicable) or any other program, since these third-party online sites are owned and operated independently from us.
              Any information collected by these third parties is governed by the privacy policy, if any, of such third party.
            </p>
            <h2 style={{ textAlign: "left" }}>14. LEGAL DISCLAIMER</h2>
            <p>
              The Services operate ‘AS-IS’ and ‘AS-AVAILABLE’ without liability of any kind. We are not responsible for events
              beyond our direct control. Due to the complex and ever-changing nature of our technology and business, we cannot
              guarantee nor do we claim that there will be error-free performance regarding the privacy of your Personal
              Information, and we will not be liable for any indirect, incidental, consequential or punitive damages relating to
              the use or release of said Personal Information.
            </p>
            <h2 style={{ textAlign: "left" }}>15. CONSENT TO PRIVACY POLICY</h2>
            <p>Your use of our services constitutes an agreement to our Privacy Policy.</p>
            <p>
              This is our entire and exclusive Privacy Policy and it supersedes any earlier version. This Privacy Policy should be
              read in conjunction with our Terms and Conditions and any additional applicable terms posted on our platforms. We
              may periodically make changes to this Privacy Policy and will notify you of these changes by posting the modified
              terms on our Platforms. Your continued use of our services following any changes to this Privacy Policy constitutes
              your acceptance of the changes. We recommend that you revisit this Privacy Policy regularly.
            </p>
            <h2 style={{ textAlign: "left" }}>16. Other web sites</h2>
            <p>
              Our web site may contain links to other web sites, which are outside our control and are not covered by this Privacy
              Policy. If you access other sites using the links provided, the operators of these sites may collect information
              from you, which will be used by them in accordance with their privacy policy, which may differ from ours. We are not
              responsible. Solely the operators of these websites shall be responsible for their functionality or possible errors
              on the linked sites.
            </p>
            <h2 style={{ textAlign: "left" }}>17. Violation of Terms of Use</h2>
            <p>
              If a player is found to be in violation of any provision(s) stated here in the Terms of Use, this shall be
              considered as a ground for the suspension and/or cancellation of his/her account. The Company reserves the right to
              take action immediately. It is important for users to carefully read and understand the Terms of Use before using
              our service as violations could result in the loss of access to the service and potential legal consequences.
            </p>
          </div>
        </Popup>
        <div className="pannel-container">
          <div className="pannel-content">
            <a className="nav_logo fl" href="#/"></a>
            <ul className="nav_list fr ml20">
              {USER_MENUS.map((row, index) => {
                return _.includes(row.auth, parseInt(__info.usertype)) ? (
                  <NavigationMenu
                    isActive={index == this.getMenuIndex()}
                    click={(key) => {
                      () => this.setState({ navIndex: index });
                    }}
                    index={index}
                    active={navIndex == index}
                    key={index}
                    row={row}
                  />
                ) : null;
              })}
              <li className="pannel-li ads">
                {ads && (
                  <div className="extra-menus">
                    {ads.map((item, index) => (
                      <span key={index} onClick={() => window.open(item.forward.url)}>
                        <img src={item.image} />
                      </span>
                    ))}
                  </div>
                )}
              </li>
            </ul>
            <div className="cl-both"></div>
          </div>
        </div>
        <Skinning
          displaySkinning={this.state.displaySkinning}
          fatherClass={__base.ui.skin}
          hideSkinningModal={this.hideSkinningModal}
          changSkin={this.props.$$BASE.switchSkin}
        />
      </header>
    );
  }
}


reactMixin(RichHeader.prototype, ImmutableMixin);

function mapStateToProps(state) {
  return {
    __BASE: state.base,
    __USER: state.user,
    __COMMON: state.common
  }
}

function mapDispatchToProps(dispatch) {
  return {
    $$BASE: bindActionCreators(baseAction, dispatch),
    $$USER: bindActionCreators(userAction, dispatch),
    $$COMMON: bindActionCreators(commonAction, dispatch)
  }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(RichHeader)
